module.exports = __webpack_public_path__ + "img/shop-pic.c15547d7.png";